import { render } from "./TheForbidden.vue?vue&type=template&id=44572ef4&scoped=true"
const script = {}

import "./TheForbidden.vue?vue&type=style&index=0&id=44572ef4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44572ef4"]])

export default __exports__